<template>
  <div class="container-fluid">
    <div class="card mb-3" v-if="state==0" >
          <div class="card-header fs-1 fb-1">Bill of Material Query</div>
          <div class="card-body">
            <StockSearchVue @select="SelectStockCode"  PartCategory="M"></StockSearchVue>
          </div>
        </div>
    
    <div v-if="state==1">
      <div class="card mb-3 shadow p-2 mb-2" >
          <div class="card-header2 fs-4 fw-bold">Bill of Materials Query</div> 
          <searchBarVue :StockCode="CurrentStockCode" @Select="SelectStockCode" :Route="CurrentRoute"></searchBarVue>
        </div> 
      <span v-show='loading' class="position-absolute top-50 start-50 translate-middle">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          Loading...
      </span>
      
      <div class="row">
          <div class="col-5">
            <TreeViewVue :StockCode="CurrentStockCode" :Route="CurrentRoute"></TreeViewVue>
          </div>
          <div class="col-7">
            <invQueryVue :StockCode="CurrentStockCode"></invQueryVue>
          </div>
        </div>
    </div>
  </div>

</template>

<script>
import router from "@/router/index";
import StockSearchVue from '../../../components/StockSearch/StockSearch.vue';
import searchBarVue from './searchBar.vue'
import TreeViewVue from './TreeView.vue';
import invQueryVue from './invQuery.vue';
export default {
  components: {
    StockSearchVue,
    searchBarVue,
    TreeViewVue,
    invQueryVue
  },
  data: () => ({
    loading:true,
    StockCodeInput:"",
    StockListSearch:[],
    CurrentStockCode:"",
    CurrentRoute:"0",
    state:0
  }),
  watch:{
    $route (to, from){
      this.navChange();
      }
  },
  mounted(){
    this.navChange();
  },
  methods: { 
    SelectStockCode(row){ 
      router.push("/bomquery/"+row.StockCode + "/"+row.route);
      // console.log("Select Stock Code",row);
      // this.$store.commit("bomStockCode/setSelectSockCode",row.StockCode)
      // this.CurrentStockCode = row.StockCode;
      // this.state=1;
      // this.loading=false;
      
    },
    navChange(){
      if(this.$route.params.stockCode){
        this.state=1;
        this.loading=false;
        this.CurrentStockCode = this.$route.params.stockCode;
        this.CurrentRoute = this.$route.params.route;
        this.$store.commit("bomStockCode/setSelectSockCode",this.$route.params.stockCode)
      }else{
        this.state=0;
        this.loading=false;
      }
    }
  }
}
</script>

<style>
.card-header2{
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
    margin-bottom: 0;
    color: var(--bs-card-cap-color);
    background-color: var(--bs-card-cap-bg);
}
</style>